"use client";

import * as React from "react";
import type { PageHeaderV2Config } from "components/ui/v2/page-header-v2";
import { PageShell, type PageShellProps } from "./page-shell";

export interface DetailPageShellProps
  extends Omit<PageShellProps, "header"> {
  header: PageHeaderV2Config;
}

export function DetailPageShell({
  header,
  children,
  overlays,
  fab,
  ...pageShellProps
}: DetailPageShellProps) {
  return (
    <PageShell header={header} overlays={overlays} fab={fab} {...pageShellProps}>
      {children}
    </PageShell>
  );
}
